import { createContext, useContext } from "react";

const ConfigContext = createContext();

export const ConfigProvider = ({ children, isTesting}) => {
    const config = {
        webApiBaseUrl: isTesting
            ? 'http://localhost:3000/api'
            : 'https://karutamarket.com/api',
        backendApiBaseUrl: isTesting
            ? 'http://localhost:8000/api'
            : 'https://api.karutamarket.com/api',

        discordRedirectURL: isTesting
            ? 'https://discord.com/oauth2/authorize?client_id=1353777832354123837&response_type=code&redirect_uri=http%3A%2F%2Flocalhost%3A3000%2Flogin&scope=identify'
            : 'https://discord.com/oauth2/authorize?client_id=1353777832354123837&response_type=code&redirect_uri=https%3A%2F%2Fkarutamarket.com%2Flogin&scope=identify'
    };

    return (
        <ConfigContext.Provider value={config}>
            {children}
        </ConfigContext.Provider>
    );
};

export const useConfig = () => useContext(ConfigContext);